import {createSlice} from '@reduxjs/toolkit'

const menuConfigSlice = createSlice({
    name:'menuConfig',
    initialState: {
        data: null,
        status: 'idle',
        error: null,

        menuProfile: 'null',
        
        test: 'OK-OK',
        testValue: 0,
    },
    reducers: {
        setMaster: (state) => {
            state.menuProfile = 'master'
        },
        setPartnerSoloPannello: (state) => {
            state.menuProfile = 'partnerSoloPannello'
        },
        setPartnerPannelloEtQuestionario: (state) => {
            state.menuProfile = 'partnerPannelloEtQuestionario'
        },
        setAzienda: (state) => {
            state.menuProfile = 'azienda'
        }
   }
})

export const { setMaster, setPartnerSoloPannello, setPartnerPannelloEtQuestionario, setAzienda } = menuConfigSlice.actions

export const menuConfigReducer = menuConfigSlice.reducer
